import { render, staticRenderFns } from "./regret_pe.vue?vue&type=template&id=40664629&"
import script from "./regret_pe.vue?vue&type=script&lang=js&"
export * from "./regret_pe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports